import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { ScheduleButton } from '../ScheduleButton/ScheduleButton';
import { SubmitButton } from '../SubmitButton/SubmitButton';
import { VoiceButton } from '../VoiceButton/VoiceButton';
import { useInputPanelButtonsPresenter } from './InputPanelButtons.presenter';

export const InputPanelButtons: FC = observer(() => {
  const presenter = useInputPanelButtonsPresenter();

  if (presenter.isShowVoiceButton) {
    return <VoiceButton />;
  }

  if (presenter.isShowScheduleButton) {
    return <ScheduleButton />;
  }

  if (presenter.isShowSubmitButton) {
    return (
      <SubmitButton
        isSlowMode={presenter.isSlowMode}
        remainingSecond={presenter.remainingSecond}
      />
    );
  }

  return null;
});
